// shared between all modules

export const DATA_FETCHING = 'data_fetching'
export const DATA_SENDING = 'data_sending'
export const STATE_CLEARING = 'state_clearing'
export const LOAD_FLAG_SETTING = 'load_flag_setting'

// map module
export const TRAVEL_FETCHING = 'route_fetching'
export const TRAVEL_FLAG_LOADING = 'travel_flag_loading'
export const TRAVEL_SELECTION = 'travel_selection'

export const CALENDAR_FETCHING = 'calendar_fetching'
export const CALENDAR_FLAG_LOADING = 'calendar_flag_loading'

export const CRITICAL_EVENT_STATE_UPDATING = 'critical_event_state_updating'
export const USER_FEEDBACK_UPDATING = 'user_feedback_updating'

// auth module
export const AUTH_PROFILE_UPDATING = 'auth_profile_updating'
export const AUTH_STATUS_SETTING = 'auth_status_setting'
export const AUTH_USER_ROLE_UPDATING = 'auth_user_role_updating'
export const AUTH_USER_ADMIN_UPDATING = 'auth_user_admin_updating'
export const AUTH_DEBUG_VIEW_UPDATING = 'auth_debug_view_updating'
export const AUTH_MANAGER_RESTRICTED_UPDATING = 'auth_manager_restricted_updating'

// statistics module
export const USER_STATISTICS_UPDATING = 'user_statistics_updating'

// snackbar opening
export const SNACKBAR_OPENING = 'snackbar_opening'
